import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../Transition/CssTransition';
import {
    AnimatiedFormContainer,
    BackLink,
    BottomGroup,
    ButtonGroup,
    Container,
    DetailsFormContainer,
    Disclaimer,
    DisclaimerContainer,
    EmailInput,
    FormGroupWrapper,
    FormSectionContainer,
    FullNameInput,
    Info,
    PaymentButtonsContainer,
    SmallFormGroup
} from './FormComponents';
import CreditCardInputs from './CreditCardInputs';
import { PaymentTypeButton, NativePaymentsIcon } from './PaymentButtons';
import Button from '../../Button';
import TwoGroup from '../../TwoGroup';

import GetUpdatesCheckbox from '../../Widget/GetUpdatesCheckbox';
import LegalInfo from '../../Widget/LegalInfo';

import {
    onBackToAmount,
    setBraintreeDeviceInfo,
    submitDonationCompleted,
    selectPaymentProvider,
    toggleCreditCardForm,
    onOrgHunterCcValidityChange
} from '../../../containers/Donation/actions';

import MobileDetailsHeader from '../MobileDetailsHeader';
import TransitionGroupContainer from '../../Transition/TransitionGroupContainer';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../../utils/nextActionUtil';
import { CardTypes, NativePaymentsTypes, PaymentMethod } from '../../../utils/enums';
import {
    spawnPaymentTab,
    paymentPageCleanup
} from '../../../utils/donation/alternateTabPayment';

import { getCachedFullName } from '../../../utils/formCaching/helpers';
import { copyFor, capitalization } from '../../../copy/copy';
import validate from './validations';

import { Elements, StripeProvider, injectStripe } from 'react-stripe-elements';

import loadScript from '../../../utils/scriptLoader';
import config from '../../../config';

class PaymentForm extends React.Component {
    static propTypes = {
        actionIdentifier: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
        amountFormated: PropTypes.string.isRequired,
        apiRequestData: PropTypes.object.isRequired,
        awaitingBraintreeResponse: PropTypes.bool.isRequired,
        deviceData: PropTypes.string,
        endUserLocation: PropTypes.object,
        feedbackText: PropTypes.string,
        formValues: PropTypes.object,
        getUpdatesText: PropTypes.string,
        hasChoiceOfPaymentProvider: PropTypes.bool.isRequired,
        invalid: PropTypes.bool.isRequired,
        isMobile: PropTypes.bool.isRequired,
        isMultiActionsCard: PropTypes.bool.isRequired,
        isMobileResolution: PropTypes.bool.isRequired,
        onBackToAmount: PropTypes.func.isRequired,
        onPartnerClick: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        partnerLogo: PropTypes.string,
        partnerName: PropTypes.string,
        paymentInfo: PropTypes.object.isRequired,
        paymentMethod: PropTypes.string.isRequired,
        selectedAmountTime: PropTypes.instanceOf(Date),
        selectedPaymentProvider: PropTypes.number,
        selectPaymentProvider: PropTypes.func.isRequired,
        setBraintreeDeviceInfo: PropTypes.func.isRequired,
        showCreditCardForm: PropTypes.bool.isRequired,
        skipEndCard: PropTypes.bool.isRequired,
        submitDonationCompleted: PropTypes.func.isRequired,
        submitting: PropTypes.bool.isRequired,
        supportedNativePaymentTypes: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired, //eslint-disable-line
        toggleCreditCardForm: PropTypes.func.isRequired,
        valid: PropTypes.bool.isRequired,
        orgHunterCcValid: PropTypes.bool,
        onOrgHunterCcValidityChange: PropTypes.func.isRequired
    };

    handleExternalPayment(typeName) {
        this.props.setBraintreeDeviceInfo(this.props.paymentInfo);
        spawnPaymentTab(
            typeName,
            this.props.paymentInfo.trackingId,
            this.props.paymentInfo.clientToken,
            this.props.apiRequestData,
            this.props.amount,
            copyFor('general', 'applePayDonationMessage', 'donation', null, {
                partnerName: this.props.partnerName
            }),
            this.props.partnerName
        ).then(data => {
            // the other tab should have set the payment nonce on the server, so we can complete the payment now
            this.props.submitDonationCompleted(
                this.props.apiRequestData,
                {
                    trackingId: this.props.paymentInfo.trackingId,
                    ...this.props.formValues
                },
                this.props.isMultiActionsCard,
                this.props.actionIdentifier,
                this.props.selectedAmountTime,
                this.props.feedbackText,
                this.props.partnerName,
                this.props.skipEndCard,
                data.paymentProvider,
                data.providerSpecificInfo,
                this.props.deviceData
            );
        });
    }

    componentWillUnmount() {
        paymentPageCleanup();
    }

    render() {
        return (
            <DetailsFormContainer autocomplete="on">
                {this.props.isMobileResolution && (
                    <MobileDetailsHeader
                        partnerLogo={this.props.partnerLogo}
                        onPartnerClick={this.props.onPartnerClick}
                    />
                )}
                <TransitionGroup component={TransitionGroupContainer}>
                    <Container>
                        <FormSectionContainer onSubmit={this.props.onSubmit}>
                            {this.props.isMobile && (
                                <Info>
                                    {copyFor(
                                        'general',
                                        'enterPaymentInfo',
                                        'donation',
                                        capitalization.first
                                    )}
                                </Info>
                            )}
                            <div>
                                <FullNameInput autoFocus={false} />
                                <EmailInput />
                            </div>
                            {this.props.hasChoiceOfPaymentProvider &&
                                !this.props.showCreditCardForm && (
                                    <Info visible={!this.props.valid}>
                                        {copyFor(
                                            'general',
                                            'selectPaymentMethod',
                                            'donation',
                                            capitalization.first
                                        )}
                                    </Info>
                                )}
                            {(!this.props.hasChoiceOfPaymentProvider ||
                                this.props.showCreditCardForm) && (
                                <TransitionGroup>
                                    <CssTransition
                                        key="cc-form"
                                        in={this.props.showCreditCardForm}
                                    >
                                        <AnimatiedFormContainer>
                                            {this.props.isMobileResolution && (
                                                <BackLink
                                                    hidden={
                                                        !this.props
                                                            .hasChoiceOfPaymentProvider
                                                    }
                                                    onClick={() =>
                                                        this.props.toggleCreditCardForm(
                                                            this.props.showCreditCardForm
                                                        )
                                                    }
                                                >
                                                    {copyFor(
                                                        'buttons',
                                                        'backToPaymentType',
                                                        'donation',
                                                        capitalization.first
                                                    )}
                                                </BackLink>
                                            )}
                                            <CreditCardInputs
                                                paymentMethod={this.props.paymentMethod}
                                                onOrgHunterCcValidityChange={
                                                    this.props.onOrgHunterCcValidityChange
                                                }
                                            />
                                            <SmallFormGroup
                                                style={{ marginTop: '-0.5em' }}
                                            >
                                                <FormGroupWrapper>
                                                    <GetUpdatesCheckbox
                                                        isEU={
                                                            this.props.endUserLocation
                                                                .isEU
                                                        }
                                                        labelText={this.props.getUpdatesText}
                                                    />
                                                    <LegalInfo align="right" />
                                                </FormGroupWrapper>
                                            </SmallFormGroup>
                                        </AnimatiedFormContainer>
                                    </CssTransition>
                                </TransitionGroup>
                            )}
                            <PaymentButtonsContainer
                                isDesktop={!this.props.isMobileResolution}
                                id="NativePaymentButtonWrapper"
                            >
                                {!this.props.showCreditCardForm &&
                                    this.props.supportedNativePaymentTypes.map(
                                        paymentType => (
                                            <PaymentTypeButton
                                                isDesktop={!this.props.isMobileResolution}
                                                numberOfPaymentTypes={
                                                    this.props.supportedNativePaymentTypes
                                                        .length
                                                }
                                                hidden={
                                                    (!this.props
                                                        .hasChoiceOfPaymentProvider &&
                                                        !this.props.showCreditCardForm) ||
                                                    (!this.props.isMobile &&
                                                        paymentType ===
                                                            NativePaymentsTypes.applePay) ||
                                                    (!this.props.isMobile &&
                                                        paymentType ===
                                                            NativePaymentsTypes.venmo)
                                                }
                                                valid={
                                                    this.props.valid &&
                                                    !this.props.awaitingBraintreeResponse
                                                }
                                                onClick={e => {
                                                    e.preventDefault();
                                                    if (!this.props.valid) {
                                                        return;
                                                    }
                                                    this.props.selectPaymentProvider(
                                                        paymentType,
                                                        this.props.selectedPaymentProvider
                                                    );

                                                    switch (paymentType) {
                                                        case NativePaymentsTypes.applePay:
                                                            this.handleExternalPayment(
                                                                'applePay'
                                                            );
                                                            break;
                                                        case NativePaymentsTypes.googlePay:
                                                            this.handleExternalPayment(
                                                                'googlePay'
                                                            );
                                                            break;
                                                        case NativePaymentsTypes.venmo:
                                                            this.handleExternalPayment(
                                                                'venmo'
                                                            );
                                                            break;
                                                        default:
                                                            return;
                                                    }
                                                }}
                                                key={paymentType}
                                            >
                                                <NativePaymentsIcon
                                                    isDesktop={
                                                        !this.props.isMobileResolution
                                                    }
                                                    paymentType={paymentType}
                                                />
                                            </PaymentTypeButton>
                                        )
                                    )}
                            </PaymentButtonsContainer>
                            {!this.props.hasChoiceOfPaymentProvider &&
                                this.props.showCreditCardForm && (
                                    <SmallFormGroup>
                                        <FormGroupWrapper>
                                            <GetUpdatesCheckbox
                                                isEU={this.props.endUserLocation.isEU}
                                                labelText={this.props.getUpdatesText}
                                            />
                                            <LegalInfo align="right" />
                                        </FormGroupWrapper>
                                    </SmallFormGroup>
                                )}
                            <BottomGroup>
                                <ButtonGroup>
                                    <TwoGroup>
                                        <Button
                                            label={copyFor(
                                                'buttons',
                                                'back',
                                                undefined,
                                                capitalization.eachWord
                                            )}
                                            onClick={() => this.props.onBackToAmount()}
                                        />
                                        <Button
                                            style={
                                                !this.props.hasChoiceOfPaymentProvider ||
                                                this.props.showCreditCardForm
                                                    ? {}
                                                    : { visibility: 'hidden' }
                                            }
                                            primary={true}
                                            label={copyFor(
                                                'buttons',
                                                'giveWithAmount',
                                                'donation',
                                                null,
                                                {
                                                    amountFormated: `${
                                                        this.props.amountFormated
                                                    }`
                                                }
                                            )}
                                            type="submit"
                                            disabled={
                                                this.props.invalid ||
                                                this.props.submitting ||
                                                (this.props.paymentMethod ===
                                                    PaymentMethod.OrgHunter &&
                                                    !this.props.orgHunterCcValid)
                                            }
                                        />
                                    </TwoGroup>
                                </ButtonGroup>
                            </BottomGroup>
                            {this.props.isMobileResolution && (
                                <DisclaimerContainer>
                                    <Disclaimer
                                        paymentMethod={this.props.paymentMethod}
                                    />
                                </DisclaimerContainer>
                            )}
                        </FormSectionContainer>
                    </Container>
                </TransitionGroup>
            </DetailsFormContainer>
        );
    }
}

class _OrgHunterPaymentForm extends React.Component {
    async handleSubmit(e) {
        e.preventDefault();
        var data = await this.props.stripe.createToken();
        this.props.onSubmit(e, data.token.id);
    }

    render() {
        return <PaymentForm {...this.props} onSubmit={this.handleSubmit.bind(this)} />;
    }
}
_OrgHunterPaymentForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
};
var OrgHunterPaymentForm = injectStripe(_OrgHunterPaymentForm);

class OrgHunterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stripe: null
        };
    }

    componentDidMount() {
        if (window.Stripe) {
            this.onStripeLoaded();
        } else {
            this.stripeLoadReference = loadScript(
                'https://js.stripe.com/v3/',
                () => this.onStripeLoaded(),
                false,
                null
            );
        }
    }

    componentWillUnmount() {
        if (this.stripeLoadReference) {
            // clearing callback, so we don't set state on an unmounted component
            this.stringLoadReference.onload = null;
        }
    }

    onStripeLoaded() {
        const stripe = window.Stripe(config.ORG_HUNTER_PUBLIC_KEY);
        this.setState({ stripe: stripe });
    }

    render() {
        return (
            <StripeProvider stripe={this.state.stripe}>
                <Elements>
                    <OrgHunterPaymentForm {...this.props} stripe={this.state.stripe} />
                </Elements>
            </StripeProvider>
        );
    }
}

class DonationForm extends React.Component {
    render() {
        return this.props.paymentMethod === PaymentMethod.OrgHunter ? (
            <OrgHunterForm {...this.props} />
        ) : (
            <PaymentForm {...this.props} />
        );
    }
}

DonationForm.propTypes = {
    paymentMethod: PropTypes.string.isRequired
};

export default compose(
    connect(
        state => {
            const nextAction = getNextAction(
                state.widget.actions,
                state.widget.activeAction.identifier,
                buildConditionalActionsAnswerHistory(state),
                state.widget.cards
            );
            return {
                initialValues: {
                    email: state.cachedFormData.email || '',
                    fullName: getCachedFullName(state) || '',
                    getUpdates: !(state.widget.endUserLocation || {}).isEU,
                    postalCode: state.cachedFormData.postalCode || ''
                },
                isMobile: state.widget.isMobile,
                endUserLocation: state.widget.endUserLocation || {},
                apiRequestData: state.widget.apiRequestData,
                actionIdentifier: state.widget.activeAction.identifier,
                amount: state.donation.selectedAmount,
                deviceData: state.donation.deviceData,
                paymentInfo: state.donation.paymentInfo,
                feedbackText: state.widget.activeAction.thankYouText || '',
                showCreditCardForm: state.donation.showCreditCardForm,
                isMultiActionsCard:
                    state.widget.cards[state.widget.activeAction.order - 1].type ===
                    CardTypes.multipleActions,
                formValues: (state.form.donationForm || {}).values,
                getUpdatesText: state.widget.activeAction.subscriptionOptInText,
                partnerName: state.widget.activeAction.partner.name,
                selectedAmountTime: state.donation.selectedAmountTime,
                selectedPaymentProvider: state.donation.selectedPaymentProvider,
                skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction,
                awaitingBraintreeResponse: state.donation.awaitingBraintreeResponse,
                orgHunterCcValid:
                    state.donation.orgHunterCcValidity.cardNumber &&
                    state.donation.orgHunterCcValidity.expDate &&
                    state.donation.orgHunterCcValidity.cvv
            };
        },
        {
            onBackToAmount,
            submitDonationCompleted,
            selectPaymentProvider,
            setBraintreeDeviceInfo,
            toggleCreditCardForm,
            onOrgHunterCcValidityChange
        }
    ),
    reduxForm({
        destroyOnUnmount: false,
        form: 'donationForm',
        validate
    })
)(DonationForm);
